import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga de todos los PDFs. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Sirve si soy entrenador nuevo o si tengo experiencia?',
    a: 'Sí para los dos. Si sos nuevo, los tomos te dan la estructura que te falta. Si tenés experiencia, te ahorran las horas de planificación y te suman ideas nuevas.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus están incluidos en el Pack Profesional y en el Megapack Élite. La diferencia son los 2 Ebooks Élite (Sistemas Olímpicos y Acelerador Técnico).'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'HOCKEY 360 es el único sistema en Argentina que cubre todas las categorías (Escuelita a Mayores) con ejercicios graficados, planificación semanal y táctica avanzada en un solo pack.'
  }, {
    q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
    a: 'Sí. El Bonus 1 (Nivelómetro de Categorías) resuelve exactamente ese problema: tests graficados por categoría y el criterio técnico para armar tus equipos A, B y C.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si abrís el material y no es lo que esperabas, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
    a: 'Si ya planificás bien, los Ebooks Élite te dan la capa táctica olímpica que falta y más de 100 variaciones para que tus clases nunca se repitan. La mayoría de los entrenadores que ya planifican bien elige el Élite porque es donde más diferencia ven.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas, débito y transferencia bancaria. El pago es 100% seguro a través de Mercado Pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#F9F9F9] py-20 px-4" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-[#0284C7] text-center mb-12 uppercase tracking-wide" data-id="element-106">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-107">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-108">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus:bg-gray-50 transition-colors" aria-expanded={openIndex === i} data-id="element-109">
                <span className="text-lg md:text-xl font-bold text-[#0284C7] pr-8" data-id="element-110">
                  {faq.q}
                </span>
                <span className="flex-shrink-0 text-[#0284C7]" data-id="element-111">
                  {openIndex === i ? <Minus className="w-6 h-6" data-id="element-112" /> : <Plus className="w-6 h-6" data-id="element-113" />}
                </span>
              </button>

              <AnimatePresence data-id="element-114">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-115">
                    <div className="p-6 pt-0 text-gray-600 text-lg leading-relaxed border-t border-gray-100 mt-2" data-id="element-116">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}